<template>
    <div class="timeline-header">
        <div class="timeline-header__content">
            <h2 class="timeline-header__title">时间轴</h2>
            <p class="timeline-header__sub-title">共有关于
                <span class="em">{{tagName}}</span>
                的
                <span class="em">{{total}}</span>条记录
            </p>

        </div>
        <div class="timeline-header__banner">
            <img src="//cdn.airfunc.com/undraw_complete_task_u2c3.svg">
        </div>
    </div>
</template>

<script>

    export default {
        name: "TimelineHeader",
        props: {
            total: {
                type: Number,
                default: 0
            },
            tagName: {
                type: String,
                default: '全部'
            }
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";

    .timeline-header {
        display: flex;
        margin-bottom: $paddingMD;
        flex-direction: column-reverse;


        &__content {
            display: flex;
            flex-direction: column;
            width: 100%;
            padding-right: 0;
            text-align: center;
            justify-content: center;
        }

        &__title {
            color: $textColor;
            color: var(--textColor);
            font-size: $fontSizeLG;
            font-weight: $fontWeightBold;
            @include transition-colors;
        }

        &__sub-title {
            margin-top: $paddingMD;
            color: $textColor;
            color: var(--textColor);
            font-size: $fontSize;
            @include transition-colors;

            .em {
                margin: 0 $paddingBase;
                font-weight: $fontWeightBolder;
                color: $primaryColor;
                color: var(--primaryColor);
                @include transition-colors;

            }
        }

        &__banner {
            width: 60%;
            margin: 0 auto $paddingMD;
            display: flex;
            align-items: flex-end;
        }

    }




    @media (min-width: 1024px) {
        .timeline-header {
            flex-direction: row;
            &__content {
                width: 70%;
                padding-right: $paddingMD;
                text-align: left;
            }

            &__banner {
                width: 30%;
                margin: 0;
            }
        }
    }
</style>